import { render, staticRenderFns } from "./Loadmore.vue?vue&type=template&id=a477aa20"
import script from "./Loadmore.vue?vue&type=script&lang=js"
export * from "./Loadmore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports